import Modal from "react-modal";
import loading from "../../images/Loading.gif";
import { LoadingModalStyles } from "../../styles/CustomModalStyles";
interface Props {
  flag: boolean;
  message?: string;
  forMobile?: boolean;
}
const LoadingModal = ({ flag, message, forMobile }: Props) => {
  return (
    <Modal
      shouldCloseOnOverlayClick={true}
      isOpen={flag}
      style={LoadingModalStyles}
      ariaHideApp={false}
    >
      <div className="loading-time">
        <span> {message ? message : "Loading..."}</span>
        <br />
        <img
          src={loading}
          alt="loading"
          className={forMobile ? "loading-gif-mobile" : "loading-gif"}
        />
      </div>
    </Modal>
  );
};

export default LoadingModal;
